import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import { Img, ImgWrapper, Progress, Wrapper } from "./LoadingSpinner.styled";

const LoadingSpinner = ({ onFinish }) => {
  const [value, setValue] = useState(0);
  const { t } = useTranslation();

  const intervalIdRef = useRef(null);

  useEffect(() => {
    if (value < 100) {
      intervalIdRef.current = setInterval(() => {
        setValue(prevState => prevState + 1);
      }, 50);
    } else {
      clearInterval(intervalIdRef.current);

      if (onFinish) onFinish();
    }

    return () => clearInterval(intervalIdRef.current);
  }, [value, onFinish]);

  return (
    <Wrapper>
      <ImgWrapper animate={value < 100}>
        <Img src="/assets/images/circle.png" alt="circle" />
      </ImgWrapper>
      <Progress>{t("global.circleLoading", { value })}</Progress>
    </Wrapper>
  );
};

export default LoadingSpinner;
